import React, { useState, useEffect } from 'react';
import NavLinks from '../Navbar/NavLinks';
import { HashLink } from 'react-router-hash-link';
import BrandLogo from '../BrandLogo';


const NavBar = () => {
    const [top, setTop] = useState(!window.scrollY);
    const [isOpen, setisOpen] = React.useState(false);
    function handleClick() {
        setisOpen(!isOpen);
    }


    useEffect(() => {
      const scrollHandler = () => {
        window.pageYOffset > 10 ? setTop(false) : setTop(true)
      };
      window.addEventListener('scroll', scrollHandler);
      return () => window.removeEventListener('scroll', scrollHandler);
    }, [top]);

    return (
        <nav aria-label="Main navigation" className={`fixed top-0 w-full bg-white z-30 transition duration-300 ease-in-out ${!top ? 'shadow-lg' : ''}`}>
            <div className="mx-auto max-w-screen-2xl flex flex-row justify-between gap-4 items-center px-4 sm:px-8 py-2">
                <div className="flex shrink-0 items-center font-semibold">
                    <HashLink smooth to="/#hero" className="mcn-brand-link"><BrandLogo /></HashLink>
                    
                </div>
                <div className="group flex flex-col items-center">
                    <button type="button" aria-label={isOpen ? 'Close navigation' : 'Open navigation'} aria-expanded={isOpen} aria-controls="mobile-navigation" className="p-2 rounded-lg xl:hidden text-blue-900" onClick={handleClick}>
                        <svg className="h-6 w-6 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            {isOpen && (
                            <path fillRule="evenodd" clipRule="evenodd" d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z" />
                            )}
                            {!isOpen && (
                            <path fillRule="evenodd" d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z" />
                            )}
                        </svg>
                    </button>
                    <div className='hidden xl:flex items-center whitespace-nowrap'>
                        <NavLinks />
                    </div>

                    <div id="mobile-navigation" onClick={(event) => { if (event.target.closest('a')) setisOpen(false); }} className={`absolute top-full justify-center left-0 w-full rounded-md px-6 py-8 bg-white xl:hidden shadow-xl ${isOpen ? "flex" : "hidden"}`}>
                        <div className='flex flex-col space-y-6'>
                            <NavLinks />
                        </div>                                                
                    </div>

                </div>
            </div>
        </nav>
    )
    
}


export default NavBar;
